import React from 'react';
import { getRolesSelector, getUserSelector } from '../appContainer/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const stateSelector = createStructuredSelector({
  userRolesHOC: getRolesSelector,
  userObjHOC: getUserSelector,
});

const HiddenForRoles = WrappedComponent => {
  class WrappedComponentClass extends React.Component {
    render() {
      const { userObjHOC, userRolesHOC, hiddenForRoles, ...rest } = this.props;
      const userLoaded = !!Object.keys(userObjHOC).length && !!Object.keys(userRolesHOC).length;
      const userRole = userRolesHOC[userObjHOC.role];
      const shouldBeHidden = hiddenForRoles && hiddenForRoles.length ? hiddenForRoles.includes(userRole) : false;

      if (userLoaded && shouldBeHidden) {
        return null;
      }

      return <WrappedComponent {...rest} />;
    }
  }

  return connect(stateSelector)(WrappedComponentClass);
};

export default HiddenForRoles;
